export function sortData(data, sortOrder = 'asc') {
  return data.sort((a, b) => {
    if (a.no_assessment_assigned === 0 && b.no_assessment_assigned !== 0) return 1;
    if (a.no_assessment_assigned !== 0 && b.no_assessment_assigned === 0) return -1;
    if (a.overall_score !== b.overall_score) {
      return sortOrder === 'asc'
        ? a.overall_score - b.overall_score
        : b.overall_score - a.overall_score;
    }
    return sortOrder === 'asc'
      ? a.no_assessment_assigned - b.no_assessment_assigned
      : b.no_assessment_assigned - a.no_assessment_assigned;
  });
}

export const years = new Date().getFullYear();
export const upcomming_year = `${years}-${years + 1}`;
export const downcomming_year = `${years - 1}-${years}`;
// export const downcomming_year = `${years - 1}-${years}`;
export const YEAR_SELECTER = [upcomming_year];


export const getPrevSession = (sessionStr) => {
  try {
    const parts = String(sessionStr).split('-');
    const start = parseInt(parts?.[0], 10);
    const end = parseInt(parts?.[1], 10);
    if (Number.isFinite(start) && Number.isFinite(end)) {
      return `${start - 1}-${end - 1}`;
    }
  } catch (e) {}
  return sessionStr;
};